export default "__VITE_ASSET__6dfe678b__"